import { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import { Dialog } from "../Dialog";

const ImageCropper = ({
  imageSrc,
  onCropDone,
  open,
  setOpen,
  onCancel,
  areaPixel,
  quality = 0.95,
}: {
  imageSrc: string;
  onCropDone: (croppedImage: Blob) => void;
  onCancel: () => void;
  open: boolean;
  setOpen: any;
  areaPixel: any;
  quality?: number;
}) => {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<any>(null);

  const onCropComplete = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const cropImage = async () => {
    const image = new Image();
    image.src = imageSrc;
    await new Promise((r) => (image.onload = r));

    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    if (!ctx) return;

    canvas.width = areaPixel?.width
      ? areaPixel?.width
      : croppedAreaPixels.width;
    canvas.height = areaPixel?.height
      ? areaPixel?.height
      : croppedAreaPixels.height;

    ctx.drawImage(
      image,
      croppedAreaPixels.x,
      croppedAreaPixels.y,
      croppedAreaPixels.width,
      croppedAreaPixels.height,
      0,
      0,
      canvas.width,
      canvas.height
    );

    canvas.toBlob(
      (blob) => {
        if (blob) {
          onCropDone(blob);
          setOpen(false);
        }
      },
      "image/jpeg",
      quality
    );
  };

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={<h2 className="text-2xl font-bold">Crop Image</h2>}
      onSave={cropImage}
      saveText="Crop"
      onCancel={onCancel}
    >
      <div className="relative w-full h-[400px] bg-black">
        <Cropper
          image={imageSrc}
          crop={crop}
          zoom={zoom}
          aspect={areaPixel ? areaPixel.width / areaPixel.height : 1} // Change ratio (1 for square, 16/9 for rectangle, etc.)
          onCropChange={setCrop}
          onZoomChange={setZoom}
          onCropComplete={onCropComplete}
        />
      </div>
    </Dialog>
  );
};

export default ImageCropper;
